import { memo } from "react";
import { withSx } from "ui/atoms/Modal";
import { BasicDialog } from "ui/molecules/Dialog";
import ActionPanel from "ui/molecules/ActionPanel";
import { usePaymentMethodsContext } from "../PaymentMethodsProvider";
import {
    PaymentMethodDetail,
    PaymentMethodDetailProvider,
    usePaymentMethodContext
} from "../PaymentMethod";

const DuplicateDialogBody = ({ onClose }: { readonly onClose: () => void }) => {
    const {
        isProcessing,
        hasActiveChanges,
        updateOrCreate,
        reset
    } = usePaymentMethodContext();

    return (
        <BasicDialog
            isOpen={true}
            onClose={onClose}
            disableCloseOnBackdropClick
            titleSlot='Duplicate Payment Method'
            DialogProps={withSx({
                maxWidth: 'lg'
            })}
            actionsSlot={(
                <ActionPanel
                    sx={{
                        border: 'none',
                        p: 0,
                        m: 0
                    }}
                    CancelActionProps={{
                        disabled: isProcessing
                    }}
                    SaveActionProps={{
                        children: 'Create Method',
                        disabled: !hasActiveChanges(),
                        loading: isProcessing
                    }}
                    onCancel={onClose}
                    onSave={() => (
                        updateOrCreate()
                            .then(onClose)
                            .then(reset)
                    )}
                />
            )}
        >
            <PaymentMethodDetail />
        </BasicDialog>
    );
};

const DuplicatePaymentMethodDialog = () => {
    const { duplicateSeed, dismissDuplicate } = usePaymentMethodsContext();

    if (!duplicateSeed) {
        return null;
    }

    return (
        <PaymentMethodDetailProvider
            useCaseDiscriminationKey='create'
            paymentMethod={duplicateSeed}
        >
            <DuplicateDialogBody
                onClose={dismissDuplicate}
            />
        </PaymentMethodDetailProvider>
    );
};

export default memo(DuplicatePaymentMethodDialog);
